<--代理商诊所医生订单统计-->
<template>
    <div>
        <div style="padding:0 20px">
            <div class="top">
                <el-date-picker
                        v-model="date"
                        type="daterange"
                        align="right"
                        @change="dateChange"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                </el-date-picker>
                <el-select
                        v-model="query.agentNo"
                        size="small"
                        placeholder="代理商" style="width: 120px;margin-right: 10px"
                        @change="selectHospital"
                >
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option
                            v-for="item in agentList"
                            :key="item.agentNo"
                            :label="item.agentName"
                            :value="item.agentNo">
                    </el-option>
                </el-select>

                <el-select
                        size="small"
                        placeholder="诊所" style="width: 170px" v-model="query.hospitalNo"  @change="select">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option

                            v-for="item in hospitalList"
                            :key="item.hospitalNo"
                            :label="item.hospitalName"
                            :value="item.hospitalNo">
                    </el-option>
                </el-select>
                <el-button type="primary" @click="all()" style="height: 30px">查询全部</el-button>
            </div>
            <div class="then">
                <div class="then-in" style="margin-left: 12%">
                    <span>接诊数</span>
                    <span class="then-in-number">{{chartData.count}}</span>
                </div>
                <div class="line"></div>
                <div class="then-in" style="margin-right: 12%">
                    <span>接诊金额</span>
                    <span class="then-in-number" style="color:rgba(255,148,89,1);" v-if="username =='上海复旦大学附属金山医院'">

                        {{chartData.drugAmt}}
                    </span>
                    <span class="then-in-number" style="color:rgba(255,148,89,1);" v-else>
                        {{chartData.totalAmt}}
                    </span>
                </div>
                <div class="then-in" style="margin-right: 12%">
                    <span>药品金额</span>
                    <span class="then-in-number" style="color:rgba(255,148,89,1);">{{chartData.drugAmt}}</span>
                </div>
            </div>
            <div class="chart-box">
                <div id="count"></div>
                <div id="totalAmt"></div>
            </div>
            <el-table :data="list"
                      :header-cell-style="{'padding-left': '10%'}"
                      :cell-style="{'padding-left': '10%'}">

                <el-table-column label="代理商" sortable>
                    <template slot-scope="scope">
                        <div>{{scope.row.agentName}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="诊所" sortable>
                    <template slot-scope="scope">
                        <div>{{scope.row.hospitalName}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="doctorName" label="医生"></el-table-column>
                <el-table-column prop="count" label="接诊数"></el-table-column>
                <el-table-column prop="totalAmt" label="订单金额">
                    <template slot-scope="scope" v-if="scope.row.hospitalName =='上海复旦大学附属金山医院'">
                        <div>{{scope.row.drugAmt}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="drugAmt" label="药品金额"></el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page="pageNum"
                        :page-size="pageSize"
                        :total="total"
                        @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Chart } from '@antv/g2';
    import getDate from "../common/dataFormat";
    import revert from "../common/revert";
    export default {
        data() {
            return {
                list:[],
                authorization: localStorage.getItem('authorization'),
                username:localStorage.getItem('ms_username'),
                hospitalList: [],
                agentList: [],
                date: '',
                pickerOptions: {
                    shortcuts: [{
                        text: '本周',
                        onClick(picker) {
                            const end = getDate.getCurrWeekDays().endtime;
                            const start = getDate.getCurrWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上周',
                        onClick(picker) {
                            const end = getDate.getLastWeekDays().endtime;
                            const start = getDate.getLastWeekDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '本月',
                        onClick(picker) {
                            const end = getDate.getCurrMonthDays().endtime;
                            const start = getDate.getCurrMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '上月',
                        onClick(picker) {
                            const end = getDate.getLastMonthDays().endtime;
                            const start = getDate.getLastMonthDays().starttime;
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                radioDate: '本周',
                handleDate: '',
                chartData: [
                ],
                // 分页信息
                pageNum: 1,
                pageSize: 10,
                total: 1,
                pages: 1,
                query: {
                    hospitalNo: "",
                    endTime: "",
                    startTime: "",
                    agentNo:"",
                    doctorName:""
                }
            }
        },
        methods: {
            all(){
                this.query.agentNo=""
                this.query.hospitalNo=""
                this.getDate()
            },
            selectHospital() {
                this.axios.post('/api-b/10018/100095/1/1000', {
                        queryParam: "",
                        auditStatus: "",
                        agentNo: this.query.agentNo
                    },
                    {
                        headers: {
                            Authorization: this.authorization
                        }
                    }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length > 0) {
                            this.hospitalList = res.data.data.list
                            this.query.hospitalNo=this.hospitalList[0].hospitalNo
                        } else {
                            this.hospitalList = []
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            select(){

                this.axios.post('/api-s/10009/100187', this.query, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data != null) {
                            this.chartData = res.data.data
                            this.total=this.chartData.list.length
                            let start = this.pageSize * (this.pageNum - 1)
                            let end = this.pageSize * this.pageNum
                            this.list = []
                            for (let i = start; i < end; i++) {
                                if (i < end) {
                                    if ( this.chartData.list[i]) {
                                        this.list.push( this.chartData.list[i])
                                    } else {
                                        break
                                    }
                                }
                            }
                            this.createNumberChart(this.list);
                            this.createValueChart(this.list);

                        } else {
                            this.chartData = {}
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getDate(){
                this.agentList = []
                this.chartData = {}


                this.axios.post('/api-b/10037/100127', {
                    pageNum: 1,
                    pageSize: 100
                }, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length > 0) {
                            this.agentList=res.data.data.list
                            this.query.agentNo=this.agentList[0].agentNo
                        } else {
                            this.agentList = []
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })

                this.axios.post('/api-s/10009/100187', this.query, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data != null) {
                            this.chartData = res.data.data
                            this.total=this.chartData.list.length
                            let start = this.pageSize * (this.pageNum - 1)
                            let end = this.pageSize * this.pageNum
                            this.list = []
                            for (let i = start; i < end; i++) {
                                if (i < end) {
                                    if ( this.chartData.list[i]) {
                                        this.list.push( this.chartData.list[i])
                                    } else {
                                        break
                                    }
                                }
                            }
                            this.createNumberChart(this.list);
                            this.createValueChart(this.list);

                        } else {
                            this.chartData = {}
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getDate1() {
                this.agentList = []
                this.chartData = {}

                this.axios.post('/api-b/10037/100127', {
                    pageNum: 1,
                    pageSize: 100
                }, {
                    headers: {
                        Authorization: this.authorization
                    }
                }).then(res => {
                    if (res.data.code === 10000) {
                        if (res.data.data.list.length > 0) {
                            this.agentList=res.data.data.list
                            this.query.agentNo=this.agentList[0].agentNo
                            this.axios.post('/api-b/10018/100095/1/1000', {
                                    queryParam: "",
                                    auditStatus: "",
                                    agentNo: this.query.agentNo
                                },
                                {
                                    headers: {
                                        Authorization: this.authorization
                                    }
                                }).then(res => {
                                console.log(res)
                                if (res.data.code === 10000) {

                                    if (res.data.data.list!=null) {
                                        this.hospitalList = res.data.data.list
                                        this.query.hospitalNo=this.hospitalList[0].hospitalNo
                                        this.axios.post('/api-s/10009/100187', this.query, {
                                            headers: {
                                                Authorization: this.authorization
                                            }
                                        }).then(res => {
                                            if (res.data.code === 10000) {
                                                if (res.data.data != null) {
                                                    this.chartData = res.data.data
                                                    this.total=this.chartData.list.length
                                                    let start = this.pageSize * (this.pageNum - 1)
                                                    let end = this.pageSize * this.pageNum
                                                    this.list = []
                                                    for (let i = start; i < end; i++) {
                                                        if (i < end) {
                                                            if ( this.chartData.list[i]) {
                                                                this.list.push( this.chartData.list[i])
                                                            } else {
                                                                break
                                                            }
                                                        }
                                                    }
                                                    this.createNumberChart(this.list);
                                                    this.createValueChart(this.list);

                                                } else {
                                                    this.chartData = {}
                                                }

                                            } else {
                                                this.$message.error(res.data.message)
                                            }
                                        })

                                    } else {
                                        this.hospitalList = []
                                    }
                                } else {
                                    this.$message.error(res.data.message)
                                }
                            })
                        } else {
                            this.agentList = []
                        }

                    } else {
                        this.$message.error(res.data.message)
                    }
                })

            },
            createNumberChart(data) {
                document.getElementById("count").innerHTML="<div id=\"count\"></div>";
                let chart = new Chart({
                    container: 'count',
                    autoFit: false,
                    width: 780,
                    height: 420,
                });
                chart.data(data);
                chart.interval().position('doctorName*count').color('#d0e6ff')
                chart.scale({
                    count:{
                        min: 0,
                        nice: true,
                        alias: '接诊数',
                    },
                });

                chart.render();
            },
            createValueChart(data) {
                document.getElementById("totalAmt").innerHTML="<div id=\"totalAmt\"></div>";
                let chart = new Chart({
                    container: 'totalAmt',
                    autoFit: false,
                    width: 780,
                    height: 420,
                });
                chart.data(data);
                chart.interval().position('doctorName*totalAmt').color('#d0fedc')
                chart.scale({
                    totalAmt:{
                        min: 0,
                        nice: true,
                        alias: '接诊金额',
                    },
                });

                chart.render();
            },
            // 表格换页
            handlePageChange(val) {
                this.pageNum = val;
                let start = this.pageSize * (this.pageNum - 1)
                let end = this.pageSize * this.pageNum
                this.list = []
                for (let i = start; i < end; i++) {
                    if (i < end) {
                        if ( this.chartData.list[i]) {
                            this.list.push( this.chartData.list[i])
                        } else {
                            break
                        }
                    }
                }
                this.createNumberChart(this.list);
                this.createValueChart(this.list);
            },
            dateChange(val) {
                this.query.startTime = val[0]
                this.query.endTime = val[1]
                this.select()

            }
        },
        created() {
            this.date = [
                getDate.getCurrWeekDays().starttime, getDate.getCurrWeekDays().endtime
            ]
            this.query.endTime = getDate.getCurrWeekDays().endtime;
            this.query.startTime = getDate.getCurrWeekDays().starttime;
            this.getDate1()
        },

    }

</script>
<style>

</style>
<style scoped>
    .top {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 13px;
        height: 52px;
    }
    .then {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height:112px;
        background:rgba(251,254,255,1);
        border-radius:4px;
        border:1px solid rgba(210,237,255,1);
        margin-bottom: 20px;
    }
    .then-in {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        height: 70px;
        color:rgba(102,102,102,1);
        font-size: 14px;
    }
    .then-in-number {
        font-size:30px;
        font-weight:bold;
        color:rgba(97,167,255,1);
    }
    .line {
        width:1px;
        height:112px;
        background: rgba(210,237,255,1);
    }
    .chart-box{
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        padding: 30px 0;
        width: 100%;
        height:423px;
        background:rgba(251,254,255,1);
        border-radius:8px;
        border:1px solid rgba(210,237,255,1);
        margin-bottom: 20px;
    }
</style>